import * as React from 'react'
import * as ReactDOM from 'react-dom'

export class Frame extends React.Component<
  {
    children: string | JSX.Element
    extraHeadInjectables?: string
    style?: { [key: string]: string }
    onLoad?: ({ height, width }) => void
  },
  any
> {
  constructor(props) {
    super(props)
    this.state = {
      iFrameHeight: '0px',
      iFrameWidth: '0px',
    }
  }

  public componentDidMount() {
    this.update()
  }

  public componentDidUpdate(prevProps) {
    if (this.props.children !== prevProps.children) {
      this.update()
    }
  }

  private update() {
    const { children, extraHeadInjectables } = this.props
    ReactDOM.findDOMNode(this).contentWindow.document.open('text/html')
    let content = children
    if (extraHeadInjectables && typeof children === 'string') {
      const [initial, htmlTag, ...rest] = (content as string).split(/(<html[^>]*>)/)
      content = `${initial}${htmlTag}${extraHeadInjectables}${rest}`
    }
    ReactDOM.findDOMNode(this).contentWindow.document.write(content as string)
    ReactDOM.findDOMNode(this).contentWindow.document.close()
  }

  public render() {
    return (
      <iframe
        scrolling="no"
        style={{ height: this.state.iFrameHeight, ...(this.props.style || {}) }}
        onLoad={() => {
          const height = ReactDOM.findDOMNode(this).contentWindow.document.body.scrollHeight
          const width = ReactDOM.findDOMNode(this).contentWindow.document.body.scrollWidth
          this.setState({
            iFrameHeight: height + 'px',
            iFrameWidth: width + 'px',
          })
          this.props.onLoad && this.props.onLoad({ height, width })
        }}
      />
    )
  }
}
